import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight, Quotes } from "@phosphor-icons/react";

const TEAM = [
  {
    name: "Ali Kiyani",
    role: "Managing Director",
    tag: "17+ years in recruitment",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_xml-job-board/artifacts/sv90xm5p_updated.png",
    heading: "A message from our founder",
    emphasis: [
      "That was one of the reasons I started Vacancy Network.",
      "I wanted Vacancy Network to approach things differently.",
    ],
    message: [
      "I have spent more than 17 years working in recruitment, including working with some of the largest recruitment businesses in the world. During that time I have seen the industry change considerably. Technology has made it easier than ever to find vacancies and reach candidates, but I also feel that recruitment has lost some of the personal value that made it such an important industry in the first place.",
      "That was one of the reasons I started Vacancy Network.",
      "Candidates are applying for more jobs than ever, yet many receive little or no communication afterwards. Employers can receive hundreds of applications and still struggle to find the right people. There are more job boards, recruitment platforms and technologies available than ever before, but the overall experience has not necessarily become better.",
      "I wanted Vacancy Network to approach things differently.",
      "For me, it is about bringing value back to recruitment and creating a better experience for everyone involved. We want to make it easier for people to find opportunities that are genuinely relevant to them while helping employers connect with the people they are actually looking for.",
      "Technology is a huge part of modern recruitment and we embrace that, but it should make recruitment better, not remove the human element from it. We want to use technology to make things simpler, faster and more effective while remembering that behind every application is a real person looking for their next opportunity.",
      "Vacancy Network was not created simply to become another place to advertise jobs. The ambition is to build a genuine network that connects people, employers and opportunities and improves the experience on both sides.",
      "After 17 years in recruitment, I still believe this industry has an enormous amount of value to offer. I started Vacancy Network because I believe we can do recruitment better and create something that people actually enjoy using.",
    ],
  },
  {
    name: "Sarah Hughes",
    role: "International Senior Recruiter",
    tag: "UK & US recruitment experience",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_xml-job-board/artifacts/q3mkoa5w_ChatGPT%20Image%20Aug%2020%2C%202026%2C%2005_06_54%20PM.png",
    heading: "Meet Sarah",
    emphasis: [
      "That is what I bring to Vacancy Network.",
    ],
    message: [
      "Recruitment has been a huge part of my life. I started in the industry at just 18 years old as a Trainee Recruitment Consultant with JPL Recruitment, and it quickly became something I knew I wanted to build my career around.",
      "Over the years I worked my way through the industry, learning recruitment from the ground up and gaining experience across different sectors, businesses and markets.",
      "One of the biggest chapters of my career came when I had the opportunity to move to the United States and head up my own branch. I spent seven years working in the US, which gave me a completely different perspective on recruitment and the opportunity to work with candidates and employers across an international market.",
      "After seven years in America, I made the decision to return to the UK to spend more time with my family and raise a family of my own.",
      "Having worked in recruitment since I was 18, I have seen just how much the industry has changed. Systems and technology have moved forward enormously, but for me good recruitment still comes down to understanding people. It is about listening to what a candidate actually wants, understanding what an employer really needs and making sure the opportunity is right for both.",
      "That is what I bring to Vacancy Network. My experience in both the UK and US has taught me that although recruitment markets can be very different, people ultimately want the same thing. Candidates want genuine opportunities and employers want great people.",
      "My role at Vacancy Network is about helping us create that connection and making the recruitment experience feel more personal again.",
    ],
  },
  {
    name: "Hannah Stevens",
    role: "Recruitment Consultant",
    tag: "In recruitment since 2019",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_xml-job-board/artifacts/ol4pq7rj_ChatGPT%20Image%20Aug%2020%2C%202026%2C%2012_10_08%20PM.png",
    heading: "Meet Hannah",
    emphasis: [
      "I wanted to do things differently.",
      "We will be there every step of the way.",
    ],
    message: [
      "I have worked in recruitment since 2019, but my experience of the industry actually started on the other side of the desk.",
      "Before becoming a recruiter myself, I worked in temporary roles through recruitment agencies. Unfortunately, my experience was not always a positive one. I often felt like I was just another number. There was very little interest in where I wanted my career to go or what I wanted to achieve in the future. It sometimes felt like finding me the next available job was more important than finding me the right one.",
      "Like anyone else, I wanted a real opportunity to build a career and create something for myself. That experience played a big part in my decision to move into recruitment in 2019.",
      "I wanted to do things differently.",
      "For me, recruitment is about much more than filling a vacancy. I want the candidates I work with to feel valued, listened to and supported. I want to understand where they want to go, not just where they can go today.",
      "That is one of the reasons I love what we are building at Vacancy Network. We do not want to simply help someone find their next job and then disappear. We want to support people throughout their journey and help them build a career they can genuinely be proud of.",
      "Everyone has different ambitions and their own idea of success. Our job is to listen, understand those ambitions and help people get there.",
      "Whether you are looking for your first opportunity, changing direction or working towards the next stage of your career, we want you to know that you are more than an application or a number to us.",
      "We will be there every step of the way.",
    ],
  },
  {
    name: "Edwin Raj",
    role: "Partnerships & Account Manager",
    tag: "Affiliate & performance marketing background",
    img: "https://static.prod-images.emergentagent.com/jobs/d98a791f-86f0-401b-90f0-5668ae659e17/images/dcf9654a6a6fb0812ffa6e690bd2430d8771998caeae5885be93132eba98d907.jpeg",
    heading: "Meet Edwin",
    emphasis: [
      "It is all about building long-term relationships that create genuine value.",
    ],
    message: [
      "Edwin Raj is the Partnerships & Account Manager at Vacancy Network, responsible for developing and managing relationships with job boards, aggregators, publishers and other strategic partners.",
      "He brings a background in affiliate marketing, performance marketing, SEO and commercial partnership development, with hands-on experience across publisher and advertiser relationships, campaign onboarding and performance optimisation. His previous experience includes managing partner relationships, supporting revenue growth and working with performance-based models designed to improve reach and return on investment.",
      "At Vacancy Network, Edwin plays an important role in expanding the company's commercial network, supporting CPC and CPA partnerships and helping to build a strong foundation for future growth. He works closely with the wider team to identify partnership opportunities, improve job distribution and ensure Vacancy Network continues to grow as a credible and commercially focused job advertising platform.",
      "It is all about building long-term relationships that create genuine value.",
      "Edwin's focus is on creating commercially viable opportunities and helping Vacancy Network connect quality job inventory with the right audiences across the UK and US.",
    ],
  },
];

function TeamMember({ member, index }) {
  const reversed = index % 2 === 1;
  return (
    <div className="grid gap-8 md:grid-cols-[300px_1fr] md:items-start" data-testid={`team-member-${index}`}>
      <div className={`md:sticky md:top-24 ${reversed ? "md:order-2" : ""}`}>
        <div className="overflow-hidden rounded-2xl border border-border bg-card">
          <img
            src={member.img}
            alt={`${member.name}, ${member.role} at Vacancy Network`}
            className="aspect-[4/5] w-full object-cover object-top"
            data-testid={`team-photo-${index}`}
          />
          <div className="p-5">
            <p className="font-heading text-lg font-bold">{member.name}</p>
            <p className="text-sm text-accent">{member.role}</p>
            <p className="mt-2 text-xs text-muted-foreground">{member.tag}</p>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6 md:p-8">
        <Quotes size={40} weight="fill" className="text-primary/20" />
        <h2 className="mt-2 font-heading text-2xl font-bold">{member.heading}</h2>
        <div className="mt-5 space-y-4">
          {member.message.map((para, i) => {
            const isEmphasis = member.emphasis.includes(para);
            return (
              <p key={i} className={isEmphasis ? "font-heading text-lg font-semibold text-primary" : "text-base leading-relaxed text-foreground/80"}>
                {para}
              </p>
            );
          })}
        </div>
        <div className="mt-8 border-t border-border pt-5">
          <p className="font-heading text-base font-bold">{member.name}</p>
          <p className="text-sm text-muted-foreground">{member.role}, Vacancy Network</p>
        </div>
      </div>
    </div>
  );
}

export default function About() {
  return (
    <div className="App bg-secondary/40">
      <Navbar />

      <section className="bg-navy py-16">
        <div className="mx-auto max-w-4xl px-4 md:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-accent">About Us</p>
          <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            The network built around your career
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/60">
            More jobs. Better opportunities. Real results. Bringing the human value back to recruitment.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-14 md:px-8">
        <div className="space-y-14">
          {TEAM.map((m, i) => <TeamMember key={i} member={m} index={i} />)}
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 rounded-2xl bg-navy p-8 text-center sm:flex-row sm:text-left">
          <div>
            <h3 className="font-heading text-xl font-bold text-white">Recruitment, done better.</h3>
            <p className="mt-1 text-sm text-white/60">Explore live UK & US vacancies or get in touch with our team.</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to="/jobs"><Button className="rounded-full px-6" data-testid="about-browse-jobs">Browse Jobs <ArrowRight size={16} className="ml-1" /></Button></Link>
            <Link to="/employers"><Button variant="outline" className="rounded-full border-white/20 bg-transparent px-6 text-white hover:bg-white/10 hover:text-white" data-testid="about-employers">For Employers</Button></Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
